import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  className?: string;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function CTAButton({
  text,
  className = '',
  variant = 'primary',
  fullWidth = false
}: CTAButtonProps) {
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const baseStyles = 'inline-flex items-center justify-center font-bold uppercase tracking-wide transition-all duration-200 transform hover:scale-105 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-offset-2';
  const variants = {
    primary: 'bg-[#16a34a] hover:bg-[#15803d] text-white border-b-4 border-[#166534] focus:ring-green-500',
    secondary: 'bg-[#22c55e] hover:bg-[#16a34a] text-white border-b-4 border-[#15803d] focus:ring-green-500'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const sizeClass = 'py-4 px-8 text-lg md:text-xl rounded-lg';
  return <button onClick={scrollToPurchase} className={`${baseStyles} ${variants[variant]} ${widthClass} ${sizeClass} ${className}`} data-id="element-1">
      <span data-id="element-2">{text}</span>
      <ArrowRight className="ml-2 h-6 w-6" data-id="element-3" />
    </button>;
}